// Analytics funnel — CLAUDE.md 5.1. Fires on prod only; no-op in the emulator
// so dev traffic doesn't pollute the funnel.
//
// Events: qr_scanned → page_loaded → file_selected → upload_started → upload_complete | upload_failed
//
// Firebase Analytics is optional; if the measurement ID is missing (dev) or
// analytics init fails (some browsers block it), fire() silently drops.

import type { Analytics } from 'firebase/analytics';

let analytics: Analytics | null = null;
let attempted = false;

async function init(): Promise<Analytics | null> {
  if (attempted) return analytics;
  attempted = true;
  if (import.meta.env.DEV || import.meta.env.VITE_USE_EMULATOR === '1') return null;
  try {
    const { getAnalytics, isSupported } = await import('firebase/analytics');
    const { app } = await import('./firebase');
    if (!(await isSupported())) return null;
    analytics = getAnalytics(app);
  } catch {
    analytics = null;
  }
  return analytics;
}

export type FunnelEvent =
  | 'qr_scanned'
  | 'page_loaded'
  | 'file_selected'
  | 'upload_started'
  | 'upload_complete'
  | 'upload_failed';

export async function fire(event: FunnelEvent, params: Record<string, string | number | boolean> = {}): Promise<void> {
  const a = await init();
  if (!a) return;
  const { logEvent } = await import('firebase/analytics');
  logEvent(a, event, params);
}
